/* MUI */
import { Box } from '@mui/material';

/*  React  */
import React from 'react';

/*  Components  */
import CoverPage from '../Components/Containers/CoverPage';

/*  Reports  */
import Overview from './Reports/Overview';

export const BrowserReport = (props) => {
    const { reportData, reportSetup, renderingScheduledReport } = props;

    if (!reportData) {
        return null;
    }

    return (
        <Box width="100%" data-trackid="BrowserReportMainRenderDiv">
            {reportSetup.reportSelections?.browserBrowserCover && (
                <CoverPage reportSetup={reportSetup} />
            )}
            <Overview
                data={reportData}
                renderingScheduledReport={renderingScheduledReport}
            />
        </Box>
    );
};
